import { Component, HostListener, OnDestroy, OnInit, Renderer2, ElementRef, ViewChild } from '@angular/core';
import {
  NbDialogService,
  NbMediaBreakpointsService,
  NbMenuService,
  NbSidebarService,
  NbThemeService, NbToastrService
} from '@nebular/theme';
import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ClientService } from '../../../@core/data/clients/client.service';
import * as moment from 'moment';
import { AsconActions } from '../../../pages/team/view-team/view-team.component';
import { WorksheetService, WorksheetTicketStatus } from "../../../@core/data/worksheets/worksheet.service";
import { tick } from "@angular/core/testing";
import {
  ContaTicketsModalComponent
} from "../../../pages/worksheets/conta-tickets-modal/conta-tickets-modal.component";
import { ToastrConfigs } from "../../../@core/data/toastr-config";
import { CompanyService } from "../../../@core/data/company/company.service";
import { ConfirmActionModalComponent } from '../../../pages/clients/confirm-action-modal/confirm-action-modal.component';
import { getLoggedUser } from "../../../store/users/users.selectors";
import { Store } from "@ngrx/store";
import { IAppState } from "../../../store/app.state";
import { AddEditTicketModalComponent } from '../../../pages/support/add-edit-ticket-modal/add-edit-ticket-modal.component';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  hideMenuOnClick: boolean = true;
  user: any;
  public innerWidth: any;
  public userName: string;
  public userId: string;
  public isAdmin: boolean;
  public alerts: any = [];
  public tickets: any = [];
  public bookmarks: any = [];
  public month = `${moment().month()}`;
  public year = `${moment().year()}`;
  public canSeeTickets = false;
  public canAddItTask = false;
  public alreadyShownTicketsNewNotifications = true;

  @ViewChild('ticketeElement') ticketeElement: ElementRef;
  @ViewChild('itTaskElement') itTaskElement: ElementRef;

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];
  currentTheme = 'default';

  public settingsItems = [
    {
      title: 'Taskuri fise de lucru',
      icon: 'folder-outline',
      link: '/pages/worksheets/view-tasks'
    },
    {
      title: 'Template-uri fise de lucru',
      icon: 'credit-card-outline',
      link: '/pages/worksheets/view-templates'
    },
    {
      title: 'Saga DBFile convertor',
      icon: 'file-text-outline',
      link: '/pages/saga-dbfile/view-saga-dbfile'
    },
    {
      title: 'FGO import',
      icon: 'file-text-outline',
      link: '/pages/fgo-incomes/view-fgo-incomes'
    }
  ];
  userMenu = [{ title: 'Log out' }];
  ticketsCount = 0;
  private subject = new Subject<void>();

  constructor(private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private userData: UserData,
    private store: Store<IAppState>,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private router: Router,
    private dialogService: NbDialogService,
    private companyService: CompanyService,
    private clientService: ClientService,
    private worksheetService: WorksheetService,
    private toastrService: NbToastrService,
    private renderer: Renderer2,
    private el: ElementRef,
    private cookieService: CookieService) {
    this.userId = localStorage.getItem('userId') || this.cookieService.get('UserId');
    this.getUser();
  }

  ngOnInit() {
    this.userId = localStorage.getItem('userId') || this.cookieService.get('UserId');
    this.isAdmin = this.userId === '9' || this.userId === '55' || this.userId === '72' || this.userId === '73' || this.userId === '51';
    this.currentTheme = this.themeService.currentTheme;
    this.innerWidth = window.innerWidth;
    this.userName = localStorage.getItem('adminUserName');

    this.getTickets();
    setInterval(() => {
      this.getTickets();
    }, 60000);

    this.userData.getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => this.user = users.nick);

    const { xl } = this.breakpointService.getBreakpointsMap();
    const { is } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);

    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint),
        takeUntil(this.destroy$),
      )
      .subscribe(currentBreakpoint => {
        this.userPictureOnly = currentBreakpoint.width < xl;
        this.hideMenuOnClick = currentBreakpoint.width <= is;
        if (currentBreakpoint.name === 'xs') {
        }
      });

    this.menuService.onItemClick().subscribe(() => {
      if (this.hideMenuOnClick) {
      }
    });
  }

  ngOnDestroy() {
    this.subject.next();
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  public getTickets() {
    forkJoin([
      this.worksheetService.getTicketsCountByUserId(this.userId)
    ]).subscribe({
      next: ([ticketsCountRes]) => {
        if (ticketsCountRes.status){
          this.ticketsCount = ticketsCountRes.data;
        }
        this.handleNewTickets();
      }
    });
  }

  handleNewTickets() {
    if (this.renderer && this.ticketeElement) {
      if (this.ticketsCount > 0) {
        this.renderer?.addClass(this.ticketeElement?.nativeElement, 'tickete-highlight');
      } else {
        this.renderer?.removeClass(this.ticketeElement?.nativeElement, 'tickete-highlight');
      }
    }
    if (!this.alreadyShownTicketsNewNotifications && this.ticketsCount > 0) {
      this.alreadyShownTicketsNewNotifications = true;
      this.dialogService.open(ConfirmActionModalComponent, {
        context: {
          title: 'Tickete noi',
          description: `Există ${this.ticketsCount} tichete care nu au primit un răspuns din partea ta. Dorești să vezi tichetele?`,
          withConsent: false
        },
        hasScroll: true
      }).onClose.subscribe((response: boolean) => {
        if (response) {
          this.openTicketsModal();
        }
      });
    }
  }

  public getAlerts() {
    const data = this.clientService.getAlerts();

    data.subscribe((paymentsResponse: any) => {
      this.alerts = paymentsResponse.data.map(issue => {
        return issue;
      });
    });
  }

  navigateSettings() {
    this.router.navigate(['/pages/settings']);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  hideHeader($event): void {
    document.getElementsByClassName("layout-container")[0].setAttribute('style', 'padding: 0 !important');
    document.getElementsByClassName("clients-bottom-header")[0].innerHTML = "";
    $event.currentTarget.parentElement.parentElement.parentElement.parentElement.innerHTML = "";
  }

  logout() {
    localStorage.setItem('userId', null);
    localStorage.setItem('adminUserName', null);
    this.cookieService.delete('adminToken', '/');
    this.router.navigate(['auth/login']);
  }

  getUser() {
    this.store.select(getLoggedUser).pipe(takeUntil(this.subject)).subscribe((user: any) => {
      if(!user?.user_id) return;
      this.user = user;

      this.canSeeTickets = this.user?.actions?.some(action => action.action_id == AsconActions.Clients_ViewAllClients
        || action.action_id == AsconActions.Clients_ViewTeamClients
        || action.action_id == AsconActions.Clients_ViewMyClients);

      this.canAddItTask = this.user?.actions?.some((action)=>action.action_id == AsconActions.AddSupportTickets)

      this.bookmarks = [
        {
          title: 'Lista clienti',
          link: '/pages/clients/view-clients',
          icon: 'shopping-cart-outline',
          hidden: !this.user?.actions?.some(action => action.action_id == AsconActions.Clients_ViewAllClients
            || action.action_id == AsconActions.Clients_ViewTeamClients
            || action.action_id == AsconActions.Clients_ViewMyClients)
        },
        {
          title: 'Raport Fise de lucru',
          icon: 'checkmark-square-outline',
          link: '/pages/worksheets/worksheets-report',
          hidden: !this.user?.actions?.some(action => action.action_id == AsconActions.ViewWorksheetReport)
        },
        {
          title: 'Rentabilitate',
          icon: 'activity-outline',
          link: '/pages/clients/rentability',
          hidden: !this.user?.actions?.some(action => action.action_id == AsconActions.ViewRentability)
        },
        {
          title: 'Raport financiar',
          icon: 'shopping-bag-outline',
          link: '/pages/payments/financial-report',
          hidden: !this.user?.actions?.some(action => action.action_id == AsconActions.FinancialReport)
        },
        {
          title: 'ORC',
          icon: 'inbox-outline',
          link: '/pages/orcs/view-orcs',
          hidden: !this.user?.actions?.some(action => action.action_id == AsconActions.ViewOrcs)
        },
        {
          title: 'Solduri clienti',
          icon: 'npm-outline',
          link: '/pages/incomes/view-incomes-saga',
          hidden: !this.user?.actions?.some(action => action.action_id == AsconActions.ViewSagaIncomes)
        },
        {
          title: 'Taskuri IT',
          icon: 'monitor-outline',
          link: '/pages/support/view-support',
          hidden: !user?.actions?.some(
            (action) => action.action_id == AsconActions.ViewSupportTickets
          )
        },
        {
          title: 'Registru încasare și plăți',
          icon: 'book-outline',
          link: '/pages/payments/view-incomes2',
          hidden: false
        }
      ];
    });
  }

  goToClientAccount() {
    this.companyService.goToClientAccount(this.userId, this.cookieService.get('adminToken')).subscribe((swicthAccountsResponse: any) => {
      if (swicthAccountsResponse.token) {
        localStorage.setItem('clientToken', swicthAccountsResponse.token);
        localStorage.setItem('fromAdmin', 'true');
        sessionStorage.setItem('clientToken', swicthAccountsResponse.token);
        this.cookieService.set('clientToken', swicthAccountsResponse.token, 7, '/')
        window.open('/client/app/dashboard', '_blank');
      } else {
        this.toastrService.show('A apărut o eroare', `Eroare`, ToastrConfigs.danger);
      }
    });
  }

  openTicketsModal() {
    this.dialogService.open(ContaTicketsModalComponent, {
      context: {
        clientId: null
      }
    }).onClose.subscribe((data: any) => {
      this.getTickets();
    });
  }

  newItTasksModal(){
    this.dialogService.open(AddEditTicketModalComponent, {
      context: {
        ticket:null
      }
    }).onClose.subscribe((res)=> {
    })
  }

  protected readonly tick = tick;
}
